module.exports = __webpack_public_path__ + "static/media/corn.95a61e19.svg";